import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {ResourceService} from "../../../services/resource.service";
import {BannerService} from "../../../services/banner.service";
import {first} from "rxjs/operators";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
    selector: 'app-banners-add-edit',
    templateUrl: './banners-add-edit.component.html',
    styleUrls: ['./banners-add-edit.component.scss']
})
export class BannersAddEditComponent implements OnInit {
    Editor = ClassicEditor;
    configEditor = {
        language: 'es'
    };
    form: FormGroup;
    submitted = false;
    loading = false;
    id: number;
    update = false;
    pathFile = 'Elegir Foto';
    pathFile2 = 'Elegir Foto';
    pathFile3 = 'Elegir Foto';
    banner: any = [];
    status_button: number = 0;
    constructor(
        private formBuilder: FormBuilder,
        private toastrService: ToastrService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private spinner: NgxSpinnerService,
        private resourceService: ResourceService,
        private bannerService: BannerService,
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            main_image: ['', Validators.required],
            mobile_image: '',
            main_text: null,
            active_button: '0',
            secondary_image: '',
            button_text: null,
            link_text: null,
            status: '0',
        });
        this.id = this.activatedRoute.snapshot.params['id'];
        if (this.id) {
            this.update = true;
            this.bannerService.getById(this.id).subscribe(response => {
                this.form.patchValue(response.data);
                this.banner = response.data;
                this.status_button = response.data.active_button;
            }, error => {
                this.router.navigate(['/banners']);
            });
        }
    }

    onSelectRadio(event) {
        this.form.controls.active_button.setValue(event.target.value);
        this.status_button = event.target.value;
    }
    onSelectMainPhoto(fileInput: any) {
        let photoFile = <File>fileInput.target.files[0];
        if (photoFile) {
            const formData = new FormData();
            formData.append('photo', photoFile);
            formData.append('path', 'banners');
            this.spinner.show();
            this.resourceService.uploadPhoto(formData).pipe(first()).subscribe(response => {
                this.f.main_image.setValue(response.file);
                this.pathFile = photoFile.name;
                this.spinner.hide();
            }, error => {
                this.toastrService.error(error, 'Error');
                this.spinner.hide();
            });
        }
    }

    onSelectMobilePhoto(fileInput: any) {
        let photoFile = <File>fileInput.target.files[0];
        if (photoFile) {
            const formData = new FormData();
            formData.append('photo', photoFile);
            formData.append('path', 'banners');
            this.spinner.show();
            this.resourceService.uploadPhoto(formData).pipe(first()).subscribe(response => {
                this.f.mobile_image.setValue(response.file);
                this.pathFile3 = photoFile.name;
                this.spinner.hide();
            }, error => {
                this.toastrService.error(error, 'Error');
                this.spinner.hide();
            });
        }
    }


    onSelectSecundaryPhoto(fileInput: any) {
        let photoFile = <File>fileInput.target.files[0];
        if (photoFile) {
            const formData = new FormData();
            formData.append('photo', photoFile);
            formData.append('path', 'banners');
            this.spinner.show();
            this.resourceService.uploadPhoto(formData).pipe(first()).subscribe(response => {
                this.f.secondary_image.setValue(response.file);
                this.pathFile2 = photoFile.name;
                this.spinner.hide();
            }, error => {
                this.toastrService.error(error, 'Error');
                this.spinner.hide();
            });
        }
    }

    get f() {
        return this.form.controls;
    }

    sendForm() {
        this.submitted = true;
        if (!this.form.valid) {
            return;
        }
        let item = Object.assign({}, this.form.value);
        if (this.update) {
            item.id = this.id;
            this.bannerService.update(item)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/banners']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        } else {
            this.bannerService.store(item)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/banners']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        }
    }
}
